import React from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLaptopCode,
  faUserTie,
  faCertificate,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import "./StatsCard.css";

const stats = [
  {
    value: 340,
    suffix: "+",
    label: "Online Courses",
    icon: faLaptopCode,
  },
  {
    value: 200,
    suffix: "+",
    label: "Instructors",
    icon: faUserTie,
  },
  {
    value: 100,
    suffix: "%",
    label: "Certification",
    icon: faCertificate,
  },
  {
    value: 9,
    suffix: "k+",
    label: "Membership",
    icon: faUsers,
  },
];

const StatsCard = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <section className="stats-container" ref={ref}>
      {stats.map((stat, index) => (
        <div className="stat-card" key={index}>
          <div className="icon-circle">
            <FontAwesomeIcon icon={stat.icon} size="2x" />
          </div>
          <div className="stat-text">
            <h3>
              {inView ? <CountUp start={0} end={stat.value} duration={3} /> : 0}
              {stat.suffix}
            </h3>
            <p>{stat.label}</p>
          </div>
        </div>
      ))}
    </section>
  );
};

export default StatsCard;
